import { Injectable, autobind } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';
import { removeToken, setLogin, removeLogin } from '@/utils';
import armsRum from '@/utils/armsTrackUtil';

import { UserInfo } from '@/types';

const HEARTBEAT_GAP = 2 * 60 * 1000; // 每2分钟心跳检测一次

@Injectable()
export class UserService {
  public user?: UserInfo;
  /**
   * 禁止心跳检测
   *
   * @memberof UserService
   */
  public stopHeartBeatTimerFlag = true;
  /**
   * 心跳检测的定时器
   *
   * @memberof UserService
   */
  public timer = 0;

  /**
   * 是否在iframe中的标识
   */
  public inIframe = false;

  constructor(public daoService: DaoService) {}

  public init() {
    return this.daoService
      .getCurrentUserInfoIgnoreError()
      .then(user => {
        this.user = user; // 设置当前用户信息
        armsRum.setConfig('user', { name: user.userId });
        setLogin(); // 标志当前用户已登录
        this.startHeartBeat();
      })
      .catch(e => {
        removeLogin(); // 标志当前用户未登录
        removeToken(); // 删除token
        // add sentry mark
        // if (e && e.errCode === TOKEN_INVALID_ERRCODE) {
        //   console.log('api', 'getCurrentUserInfoIgnoreError');
        // }
      });
  }

  public initUserInfo() {
    return this.daoService.getCurrentUserInfo().then(user => {
      this.user = user; // 设置当前用户信息
      if (user.userId) {
        window.sessionStorage.setItem('pc_contest_user_id', user.userId);
      }
      setLogin(); // 标志当前用户已登录
      this.startHeartBeat();
    });
  }

  @autobind
  public logout() {
    this.daoService.logout();
    this.user = undefined;
    removeToken();
    removeLogin();
    this.stopHeartBeat();
  }

  /**
   * 开始心跳检测
   *
   * @memberof UserService
   */
  public startHeartBeat() {
    if (this.stopHeartBeatTimerFlag) {
      this.stopHeartBeatTimerFlag = false;
      this.doHeartBeat();
    }
  }

  /**
   * 停止心跳检测
   *
   * @memberof UserService
   */
  public stopHeartBeat() {
    this.stopHeartBeatTimerFlag = true;
    window.clearTimeout(this.timer);
  }

  @autobind
  public doHeartBeat() {
    this.daoService.heartBeat().then(() => {
      // 2分钟后再次检测
      if (this.stopHeartBeatTimerFlag) return;
      // 清除可能存在的定时器
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(this.doHeartBeat, HEARTBEAT_GAP);
    });
  }

  /**
   * 设置是否在iframe中
   * @param bool
   */
  @autobind
  public setIframeState(bool: boolean) {
    this.inIframe = bool;
  }
}
